import { STATUS_TYPE } from '../../../enum';

export interface ServiceVendor {
  id: string;
  name: string;
  email: string;
  mainMobile: string;
  extraMobiles: string[];
  isActive: boolean;
}

export interface FindServiceVendor {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchServiceVendor {
  id?: string;
  name: string;
  email: string;
  mainMobile: string;
  extraMobiles: string[];
  isActive: boolean;
}

interface InitialState {
  data: ServiceVendor[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
